import { contact, destroy, get } from "api/flyer";

export const getFlyer = (assetID) => (dispatch) =>
  dispatch({
    type: "FLYER_GET",
    payload: get(assetID),
  }).catch(() => dispatch({ type: "FLYER_GET_REJECTED" }));

export const deleteFlyer = (flyerID) => (dispatch) =>
  dispatch({
    type: "FLYER_DELETE",
    payload: destroy(flyerID),
  });

export const contactFlyer = (assetID, values) => (dispatch) =>
  dispatch({
    type: "FLYER_CONTACT",
    payload: contact(assetID, values),
  }).catch(() => dispatch({ type: "FLYER_GET_REJECTED" }));
